<script setup lang="ts">
import { RouterView } from 'vue-router'
</script>

<template>
  <router-view />
</template>
